/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-favorite-alt-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.559 1.875c-.583 0-1.142.234-1.55.65l-.32.326-.322-.327a2.175 2.175 0 00-3.1 0 2.244 2.244 0 000 3.141l3.422 3.464 3.42-3.464a2.244 2.244 0 000-3.14 2.171 2.171 0 00-1.55-.65zM10 18.75H8.75v-3.125a1.877 1.877 0 00-1.875-1.875h-2.5A1.877 1.877 0 002.5 15.625v3.125H1.25v-3.125A3.129 3.129 0 014.375 12.5h2.5A3.129 3.129 0 0110 15.625v3.125zM5.625 6.25a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75zm0-1.25a3.125 3.125 0 100 6.25 3.125 3.125 0 000-6.25z"/>'
  }
})
